import React, { Component, Fragment } from 'react';
import { Switch, Route, NavLink, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { withRouter } from 'react-router';

import { showAccountAction } from 'store/modules/content';
import Content from 'scenes/Content';
import Styles from 'scenes/Styles';
import Analytics from 'scenes/Analytics';

import copy from 'copy-to-clipboard';
import AlertMessage from 'components/AlertMessage';

import FieldSelect from 'components/FieldSelect';
import { reloadIframe } from 'helpers/reloadIframe';
import CounterGroup from 'components/CounterGroup';
import MainInfo from 'components/MainInfo';
import CreatedAllLinks from 'components/CreatedAllLinks';
import PreviewMode from 'components/PreviewMode';
import linkCopy from 'images/link-copy.svg';
import linkGo from 'images/link-go.svg';
import leftArrow from 'images/left-arrow.svg';

import { HeaderLoggedIn } from 'scenes/Header';

import FixedFooter from 'components/FixedFooter';

class DomainPage extends Component {
  componentDidMount() {
    const { showAccountAction } = this.props;
    // const id = this.props.router
    // this.props.showAccountAction(id);
    showAccountAction(this.props.match.params.id);
  }

  state = {
    showAlert: false,
  };
  handleCopy = text => {
    copy(text);
    this.setState({ showAlert: true });
    setTimeout(() => this.setState({ showAlert: false }), 4000);
  };
  openNewTab = target => {
    window.open(target, '_blank');
  };
  render() {
    const { account, match } = this.props;
    const { showAlert } = this.state;
    const showAnalytics = window.location.href.includes('analytics');
    return (
      <Fragment>
        <HeaderLoggedIn />
        <div className="main__content main-domain">
          {showAlert && <AlertMessage text="Your link copied to clipboard!" />}
          <div className="b-row">
            <div className="std-backwards">
              <Link to="/domain" className="std-backwards_link">
                <img src={leftArrow} alt="" />
              </Link>
            </div>
            <div
              className={classnames({
                'b-col-7 b-col-sm-12 b-order-sm-2 main__content-info main-domain__left': !showAnalytics,
                'b-col-12 p-t-40 analytics-row': showAnalytics,
              })}>
              <h2 className="h2-title weight-middle">{account.title}</h2>
              <div className="domain-stat">
                <div className="domain-stat__link">
                  <div className="domain-stat__select">
                    <select
                      disabled="disabled"
                      name="domain"
                      className="domain-stat-select form-control">
                      <option defaultValue={account.domain}>
                        {account.domain + '/'}
                      </option>
                    </select>
                  </div>
                  <div className="domain-stat__shortCode">
                    <input
                      name="shortCode"
                      type="text"
                      className="domain-stat__input"
                      placeholder="Type short code here"
                      value={account.short_code}
                      disabled
                    />
                  </div>
                  <div className="domain-stat__copy">
                    <span
                      title="Copy to clipboard"
                      onClick={() =>
                        this.handleCopy(
                          account.domain + '/' + account.short_code,
                        )
                      }
                      className="link-btn__itm">
                      <img src={linkCopy} alt="" />
                    </span>
                    <span
                      title="Open in new tab"
                      onClick={() =>
                        this.openNewTab(
                          `${account.domain}/${account.short_code}`,
                        )
                      }
                      target="blank"
                      className="link-btn__itm">
                      <img src={linkGo} alt="" />
                    </span>
                  </div>
                </div>
                <CounterGroup
                  countViews={account.total_views}
                  countClicks={account.total_clicks}
                />
              </div>
              <Switch>
                <Route
                  path="/domain/page/:id/content"
                  exact
                  component={Content}
                />
                <Route
                  path="/domain/page/:id/styles"
                  exact
                  component={Styles}
                />
                <Route
                  path="/domain/page/:id/analytics"
                  exact
                  component={Analytics}
                />
                <Route path="/domain/page/:id/" component={Content} />
              </Switch>
            </div>
            {!showAnalytics && (
              <div className="b-col-5 b-col-sm-12 b-order-sm-1 main-domain__right">
                <PreviewMode />
              </div>
            )}
          </div>
        </div>
        <FixedFooter />
      </Fragment>
    );
  }
}
function mapStateProps(state) {
  return {
    token: state.auth.token,
    details: state.details.user,
    account: state.content.account,
  };
}

const mapDispatchToProps = {
  showAccountAction,
};
export default connect(
  mapStateProps,
  mapDispatchToProps,
)(withRouter(DomainPage));



// WEBPACK FOOTER //
// ./src/scenes/DomainPage/DomainPage.js